import { envConfig } from '#constants/envConfig';
import { localStorage } from '#utils/localStorage';
import { REVIEW_EARNED_KEY } from '../constants';
import {
  parseEarnedOutcome,
  type EarnedOutcome,
  type ReviewOutcomeReason,
} from '../utils/reviewGate';

/**
 * «Человек получил от продукта результат» — заработанное право спросить его об оценке.
 *
 * Ставят отметку места, которые о показе ничего не знают: ветка чата, где заговорили обе
 * стороны, и ответ «мы сыграли» в опросе после сбора. Решение о показе принимает
 * `useStoreReviewPrompt` — единственное место, которое видит экран целиком.
 *
 * Отметка переживает закрытие приложения намеренно: карточку показываем не в момент результата,
 * а в следующий заход, и между этими двумя событиями приложение обычно успевает закрыться.
 *
 * В вебе не ставится вовсе: карточка оценки существует только в приложении. `IS_NATIVE` —
 * константа времени сборки, ветка сворачивается целиком.
 */
let cached: EarnedOutcome | null | undefined;

export const readEarnedOutcome = (): EarnedOutcome | null => {
  if (cached === undefined) {
    cached = parseEarnedOutcome(localStorage.getItem(REVIEW_EARNED_KEY));
  }

  return cached;
};

/** Зовётся по факту результата — не по нажатию кнопки и не по намерению. */
export const noteOutcome = (reason: ReviewOutcomeReason) => {
  if (!envConfig.IS_NATIVE) {
    return;
  }

  // Первый повод и остаётся поводом: именно он привёл человека к карточке, и именно его
  // потом сопоставлять с отзывами. Перезапись сдвигала бы и время, отодвигая показ.
  if (readEarnedOutcome()) {
    return;
  }

  const earned: EarnedOutcome = { at: Date.now(), reason };

  cached = earned;
  localStorage.setItem(REVIEW_EARNED_KEY, JSON.stringify(earned));
};

/**
 * Снимает отметку. Зовётся только когда просьба действительно ушла в Play: если экран был
 * занят, право обязано остаться — иначе человек, которому не повезло с моментом, не будет
 * спрошен уже никогда.
 */
export const clearEarnedOutcome = () => {
  cached = null;
  localStorage.deleteItem(REVIEW_EARNED_KEY);
};
